<template>
  <highcharts :options="chartOptions" :ref="chart_id"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import moment from "moment";
export default {
  name: "pie_chart",
  props: {
    data: Array,
    chart_id: {
      type: String,
      default: "pie-chart",
    },
    config: {
      type: Object,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataset: this.data,
      chartOptions: {},
    };
  },
  methods: {
    loadPie: function () {
      let self = this;
      this.chartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: this.height != null ? this.height : 300,
          type: "pie",
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat:
            "{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        legend:
          this.config != null
            ? this.config
            : {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
                maxHeight: 100,
              },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.y}</b>",
            },
            showInLegend: true,
          },
        },
        exporting: {
          enabled: true,
        },
        series: [
          {
            name: this.dataset.name ? this.dataset.name : "Total",
            colorByPoint: true,
            data: this.dataset,
            point: {
              events: {
                click: function () {
                  let start = "";
                  let end = "";
                  let params = {};

                  start = moment(self.$route.query.from).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  end = moment(self.$route.query.to).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  let sentimen;
                  if (this.name == "Positif") {
                    sentimen = btoa(1);
                  } else if (this.name == "Netral") {
                    sentimen = btoa(0);
                  } else if (this.name == "Negatif") {
                    sentimen = btoa(-1);
                  }
                  params = {
                    from: start,
                    to: end,
                    sentiments: sentimen,
                  };

                  if ("topic_selected" in self.$route.query) {
                    params.topic_selected = self.$route.query.topic_selected;
                  }
                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        ],
      };
    },
  },
  mounted: function () {
    if (this.dataset != null) {
      this.loadPie();
    }
  },
};
</script>